export default __webpack_public_path__ + "static/media/img-3.7f83c284.jpg";